<template>
  <div>
    <!-- Mapping description block -->
    <div class="card mapping_description" qid="data-mapping-section" id="update_mapping_description">
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">

        <div class="row">
          <div class="col-sm-7">
            <div class="float-left">
              <h5 class="h5" v-if="!showOnTask">
                {{ $t('activities.mapping_description_label') }}
              </h5>
              <h5 class="h5" v-if="showOnTask">
                &nbsp;
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_mapping_description')"
                >
                  <UpdateSingleTaskModal
                      :task="myTasks[0]"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_data_mapping_description')">
                  <GuideButton :guide="getGuide('update_data_mapping_description')"></GuideButton>
                </span>
              </span>
            </div>

            <div class="validation-info" qid="view-rr-validation" v-if="validation && !showOnTask">
              <span v-if="validation && validation.validation === 1">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
                {{ $t('system.approved') }}
              </span>
                  <span v-if="validation && validation.validation === 0">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
                {{ $t('system.rejected') }}
              </span>
                  <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.by') }}
                <span v-if="validation.created_by" qid="view-rr-validation-by">
                  {{ validation.created_by.name }}
                </span>
              </span>
                  <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.on') }}
                <span v-if="validation.updated_at" qid="view-rr-validation-date">
                  {{ validation.updated_at | formatDate }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-5 text-right">
            <span class="float-right btn btn-edit"
                  @click="showMappingDescriptionInputFunction"
                  qid="activity-edit-description"
                  v-if="!showMappingDescriptionInput && isGranted([permissions.ACTIVITY_EDIT, permissions.ACTIVITY_EDIT_OWN], activity)"
            >
              <font-awesome-icon icon="pen"/>
            </span>

            <span class="float-right" v-if="showMappingDescriptionInput">
              <div class="text-right">
                <b-button class="btn btn-light"
                          variant="secondary"
                          @click="cancelMappingDescriptionForm"
                          qid="activity-edit-button-cancel"
                >
                  {{ $t('activities.create.cancel') }}
                </b-button>
                <b-button class="btn btn-success"
                          variant="success"
                          @click="formMappingDescriptionSubmit"
                          qid="activity-edit-button-submit"
                >
                  {{ $t('activities.create.submit') }}
                </b-button>
              </div>
            </span>
            <ValidationForm
                :object="activity"
                scope="validate_mapping_description"
                type="mapping_description"
                :checklist="validationOptions"
                @validationModalClose="handleValidationModalClose"
                v-if="!showOnTask && isGranted([permissions.ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VALIDATE, permissions.ACTIVITY_PRINCIPLES_OF_PROPORTIONALITY_VALIDATE_OWN], activity)"
            ></ValidationForm>
          </div>
        </div>

        <div class="content-view-body">

          <div class="mt-3">
            <div v-if="showMappingDescriptionInput">
              <b-form-textarea
                  qid="edit-tp-form-description"
                  v-model="activityEditMappingDescription"
                  rows="6"
                  :placeholder="$t('maintenance.third_parties.create.description_placeholder')"
              ></b-form-textarea>
            </div>

            <div v-if="!showMappingDescriptionInput" class="section-container">
              <div v-if="activity.mapping_description && activity.mapping_description.length > descriptionLength">
                <p v-if="showFullDescription" class="text-formatted">{{ activity.mapping_description }}</p>
                <p v-if="!showFullDescription" class="text-formatted">{{ activity.mapping_description | truncate(descriptionLength) }}</p>
                <div class="text-center mt-3" @click="showFullDescription=!showFullDescription">
                  <span class="cursor-pointer" v-if="!showFullDescription">
                    <span class="mr-2">
                      {{ $t('system.view_more') }}
                    </span>
                    <font-awesome-icon icon="chevron-down"/>
                  </span>
                  <span class="cursor-pointer" v-if="showFullDescription">
                    <span class="mr-2">
                      {{ $t('system.view_less') }}
                    </span>
                    <font-awesome-icon icon="chevron-up"/>
                  </span>
                </div>
              </div>
              <p v-if="activity.mapping_description && activity.mapping_description.length <= descriptionLength"
                 class="text-formatted"
              >{{activity.mapping_description}}</p>
              <p v-if="!activity.mapping_description" class="text-muted">
                {{ $t('system.missing_input') }}
              </p>
            </div>

          </div>
        </div>
      </div>

      <div class="text-center mb-4 card-body" v-if="!showOnTask">
        <span class="cursor-pointer"
              @click="validationShow = !validationShow"
              qid="expand-integrity-validations"
        >
          <span class="mr-2">
            {{ $t('system.view_validation_log') }}
          </span>
          <font-awesome-icon icon="chevron-down" v-if="!validationShow"/>
          <font-awesome-icon icon="chevron-up" v-if="validationShow"/>
        </span>
      </div>
      <div v-show="validationShow && !showOnTask" class="card-body">
        <ValidationList
            :object="activity"
            type="mapping_description"
            :reloadList="updateValidationList"
            @validationListUpdated="setValidation"
        ></ValidationList>
      </div>

    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import {config} from '@/config.js'
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'MappingDescriptionBlock',
    data: function() {
      return {
        activity: {},
        descriptionLength: config.descriptionLength,
        showDescriptionInput: false,
        showMappingDescriptionInput: false,
        showPurposeInput: false,
        activityEditDescription: '',
        activityEditMappingDescription: '',
        validationShow: false,
        updateValidationList: false,
        validation: {},
        validationOptions: [],
        showFullDescription: false,
        error: '',
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      submitForm: {},
      task: {}
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      },
      object: function (value) {
        this.activity = value
        this.loadTasks('update_mapping_description');
      },
      submitForm: function (value) {
        if (value) {
          if (this.showMappingDescriptionInput) {
            this.formMappingDescriptionSubmit()
          }
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.activity.id && this.$store.state.updatedObject.who_am_i == this.activity.who_am_i) {
              this.activity = this.$store.state.updatedObject
            }
          }
          this.loadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_mapping_description')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadContent()
        this.loadTasks('update_mapping_description')
      },
      setValidation(object) {
        this.validation = object
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.activity.who_am_i,
              model_id: this.activity.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Activity' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Activity',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showMappingDescriptionInputFunction() {
        this.showMappingDescriptionInput = true;
        this.activityEditMappingDescription = this.activity.mapping_description;
      },
      formMappingDescriptionSubmit() {
        let self = this;
        piincHttp.put('activities/' + this.activity.slug, {
          mapping_description: this.activityEditMappingDescription
        }).then(function(response) {
          self.activity = response.data;
          self.showMappingDescriptionInput = false;
          self.$store.commit('storeUpdateContent', self.activity);
          self.loadTasks('update_mapping_description');
          self.$toastr('success', self.$t('activities.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      cancelMappingDescriptionForm() {
        this.showMappingDescriptionInput = false;
        this.activityEditMappingDescription = this.activity.mapping_description;
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      loadContent() {
        let self = this;
        piincHttp.get('activities/' + this.activity.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.activity = response.data;
        }, function() {});
      }
    },
    created () {
      this.activity = this.object;

      if (this.showOnTask && !this.activity.mapping_description) {
        this.showMappingDescriptionInput = true;
      }

      if (this.showOnTask) {
        this.loadContent()
      }

      if (this.activity && this.activity.slug) {
        this.loadTasks('update_mapping_description');
      }

      this.loadGuides('update_data_mapping_description');

    }
  }
</script>
